'use client';

import DynamicImage from '@/components/commons/dynamic-image';
import { HeaderElementDataType } from '@/components/sections/builder/elements/header/header/type';
import { cn } from '@/lib/utils';
import React from 'react';

type ImageNavItemProps = {
  title: string;
  src: string;
  parentData?: HeaderElementDataType;
};

export default function HeaderMenuImage({ title, src, parentData }: ImageNavItemProps) {
  return (
    <div className='relative w-full'>
      <div
        className={cn(
          'absolute left-0 top-0 z-10 h-full w-full',
          parentData?.megaMenuImageOverlay ? 'bg-black opacity-10' : ''
        )}
      ></div>
      <DynamicImage
        src={src}
        alt={title}
        width={350}
        height={200}
        className='h-[350px] w-[350px] object-cover'
      />
      <h1
        className='mt-2 text-xl font-bold'
        style={{
          color: parentData?.colorSchemeMenuHeader?.text,
        }}
      >
        {title}
      </h1>
    </div>
  );
}
